import { createContext } from 'react'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'

/**
 * Archive the given inbox items now, EXCEPT those whose group is the currently
 * open sidebar selection — those are deferred (pinned) until the selection
 * moves off them, then archived. Provided only inside the inbox; null elsewhere
 * (callers then archive immediately).
 */
export type ArchiveOrDeferFn = (items: NotificationItem[]) => void

export const InboxDeferredArchiveContext =
  createContext<ArchiveOrDeferFn | null>(null)
